import React, { useState, useEffect } from "react";
import styles from "../../styles/CompanyManagement/CompanyDetails.module.css";
import { FiEdit3 } from "react-icons/fi";
import { getCompany, updateCompany } from "../../utils/api";

const OffersBenefits = ({ companyId }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    defineCategories: "",
    productBenefits: "",
    usps: "",
    PopularCategoryOrProduct: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!companyId) return;
    setLoading(true);
    setError(null);
    getCompany(companyId)
      .then((company) => {
        const offersBenefits = company.additional_infos?.offers_benefits || {};
        setFormData({
          defineCategories: offersBenefits.defineCategories || "",
          productBenefits: offersBenefits.productBenefits || "",
          usps: offersBenefits.usps || "",
          PopularCategoryOrProduct: offersBenefits.PopularCategoryOrProduct || "",
        });
      })
      .catch(() => setError("Failed to load data."))
      .finally(() => setLoading(false));
  }, [companyId]);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSaveClick = async () => {
    if (!companyId) return;
    setLoading(true);
    setError(null);
    try {
      const company = await getCompany(companyId);
      const additional_infos = { ...company.additional_infos };
      additional_infos.offers_benefits = { ...formData };
      await updateCompany(companyId, { 
        company: { 
          additional_infos 
        } 
      });
      setIsEditing(false);
    } catch {
      setError("Failed to save data.");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };


  return (
    <div className="company-management-card">
      <div className={styles.detailsHeader}>
        <span className={styles.detailsHeading}>Offer & Benefits</span>
        {!isEditing ? (
          <button className={styles.editBtn} onClick={handleEditClick} disabled={loading}>
            <FiEdit3 /> Edit
          </button>
        ) : (
          <button className={styles.saveBtn} onClick={handleSaveClick} disabled={loading}>
            Save
          </button>
        )}
      </div>
      <div className={styles.separator} />
      {error && <div className={styles.error}>{error}</div>}
      {loading ? (
        <div className={styles.detailsContent}>Loading...</div>
      ) : (
        <div className={styles.detailsContent}>
          <div className={styles.detailItem}>
            <span className={styles.detailLabel}>Define Categories</span>
            {isEditing ? (
              <input
                type="text"
                name="defineCategories"
                value={formData.defineCategories}
                onChange={handleChange}
              />
            ) : (
              <p>{formData.defineCategories}</p>
            )}
          </div>

          <div className={styles.detailItem}>
            <span className={styles.detailLabel}>What are your product benefits?</span>
            {isEditing ? (
              <input
                type="text"
                name="productBenefits"
                value={formData.productBenefits}
                onChange={handleChange}
              />
            ) : (
              <p>{formData.productBenefits}</p>
            )}
          </div>

          <div className={styles.detailItem}>
            <span className={styles.detailLabel}>What are your USPs?</span>
            {isEditing ? (
              <input
                type="text"
                name="usps"
                value={formData.usps}
                onChange={handleChange}
              />
            ) : (
              <p>{formData.usps}</p>
            )}
          </div>

          <div className={styles.detailItem}>
            <span className={styles.detailLabel}>Popular category or product</span>
            {isEditing ? (
              <input
                type="text"
                name="PopularCategoryOrProduct"
                value={formData.PopularCategoryOrProduct}
                onChange={handleChange}
              />
            ) : (
              <p>{formData.PopularCategoryOrProduct}</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default OffersBenefits;
